<template>
  <div id="nav" class="bg-gray">
    <el-tabs
      v-model="activeName"
      class="main"
      @tab-click="aClick"
    >
      <el-tab-pane
        v-for="item of navs"
        :key="item.id"
        :name="item.id"
        :label="item.name"
      >
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  export default {
    name: "NewSubNav",
    props: {
      navs: {
        type: Array,
        required: true,
        default: () => {
          return [];
        }
      },
      // 导航栏上部高度
      topHeight: {
        type: Number,
        default: 545,
      },
      single: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    data() {
      return {
        activeName: "",
        stop: false,
        timer: null,
      };
    },
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
    },
    created() {},
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        this.navs.forEach(item => {
          item.offsetTop = document.getElementById(item.id).offsetTop - 40;
        })
        let nav = document.getElementById("nav");
        let height = document.documentElement.scrollTop;
        if (height - this.topHeight > 0) {
          if (nav) nav.classList.add("fixed-tab");
        } else {
          if (nav) nav.classList.remove("fixed-tab");
        }
        if (!this.stop) {
          this.navs.forEach(item => {
            if (height > item.offsetTop) {
              this.activeName = item.id;
            }
          })
        }
        
      },
      aClick(obj) {
        if (this.single.indexOf(obj.name) != -1) {
          this.$emit('hide');
          return false;
        }
        this.$emit('show');
        this.$nextTick(_ => {
          clearTimeout(this.timer);
          // 阻止handleScroll里的滚动高亮影响点击
          this.stop = true;
          let id = obj.name;
          //页面滚动了的距离
          let height = document.documentElement.scrollTop;

          //指定dom到页面顶端的距离
          let dom = document.getElementById(id);
          let domHeight = (height - this.topHeight > 0 || dom.offsetTop == (this.topHeight + 40)) ? dom.offsetTop - 40 : dom.offsetTop - 80;
          //dom.scrollIntoView();

          //滚动距离计算
          var S = Number(height) - Number(domHeight);

          //判断上滚还是下滚
          if (S < 0) {
            //下滚
            S = Math.abs(S);
            window.scrollBy({
              top: S,
              behavior: "smooth",
            });
          } else if (S == 0) {
            //不滚
            window.scrollBy({ top: 0, behavior: "smooth" });
          } else {
            //上滚
            S = dom.offsetTop == this.topHeight ? -S + 40 : -S;
            window.scrollBy({
              top: S,
              behavior: "smooth",
            });
          }
          this.timer = setTimeout(() => {
            this.stop = false;
          }, 1000)
        })
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep {
    .el-tabs__nav-wrap::after {
      height: 0px;
    }
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__item {
      font-size: 15px;
      color: #000;
    }
    .el-tabs__item:hover {
      color: #000;
    }
    .el-tabs__active-bar {
      background-color: #0052D9;
    }
  }
  .main {
    width: 1000px;
    height: 40px;
    margin: 0 auto;
  }
  .fixed-tab {
    position: fixed;
    top: 0;
    width: 100%;
  }
</style>
